import { ArenaProblemElement } from '@/domain/entities/arena/arenaProblemElement'
import { ArenaUserEntry } from '@/domain/entities/arena/arenaUserEntry'
import { ArenaUserSubmission } from '@/domain/entities/arena/arenaUserSubmission'
import { ArenaRepository } from '@/domain/repositories/arena/ArenaRepository'

export class ArenaUseCase {
  constructor(private repository: ArenaRepository) {}

  async getByUserIdArenaEntryList(userId: string): Promise<ArenaUserEntry[]> {
    try {
      const data = await this.repository.getByUserIdArenaEntryList(userId)
      return data
    } catch (error) {
      console.error(`Error in ArenaUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }

  async getByArenaIdProblemList(arenaId: string): Promise<ArenaProblemElement[]> {
    try {
      const data = await this.repository.getByArenaIdProblemList(arenaId)
      return data
    } catch (error) {
      console.error(`Error in ArenaUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }

  async getByUserIdArenaSubmissionList(arenaId: string, userId: string): Promise<ArenaUserSubmission[]> {
    try {
      const data = await this.repository.getByUserIdArenaSubmissionList(arenaId, userId)
      return data
    } catch (error) {
      console.error(`Error in ArenaUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
